import React, { useMemo } from "react"
import SlateEditor, { useTheme } from "@convertkit/editor"
import { HTMLTemplate } from "core/html-template"
import { Before, After } from "./plugins"
import { isValidEmbedUrl } from "./utils/is-valid-embed-url"

const before = Before()
const after = After()

const defaultPropPlugins = []

export function Editor({
  plugins = defaultPropPlugins,
  html,
  css,
  style = {},
  ...props
}) {
  const activePlugins = useMemo(
    () => [...before, ...plugins, ...after],
    [before, plugins, after]
  )

  const theme = useTheme()

  // We want to override this style for non-readonly editors to fix an issue with Chrome v105
  // See https://github.com/ianstormtaylor/slate/issues/5110
  const chromeFix = props.readOnly ? {} : { WebkitUserModify: "read-write" }
  const adjustedStyle = { ...style, ...chromeFix }

  if (html) {
    return (
      <SlateEditor
        plugins={activePlugins}
        theme={theme}
        style={adjustedStyle}
        {...props}
      >
        {({ children }) => {
          return (
            <React.Fragment>
              <HTMLTemplate
                html={html}
                css={css}
                selector={"[data-document-content]"}
              >
                {children}
              </HTMLTemplate>
              {props.children}
            </React.Fragment>
          )
        }}
      </SlateEditor>
    )
  } else {
    return (
      <SlateEditor
        plugins={activePlugins}
        theme={theme}
        style={adjustedStyle}
        {...props}
      >
        {props.children}
      </SlateEditor>
    )
  }
}

export { isValidEmbedUrl }
